import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IChangeStationActivity,
  IChangeStationActivityRow,
} from '../../../../view/settings/api-automation-settings/change-station-activity/change-station-activity.model';

@Injectable({
  providedIn: 'root',
})
export class ChangeStationActivityService {
  private readonly CHANGE_STATION_ACTIVITY_URL = `${this.baseUrl}/api-automation/change-station-activity`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IChangeStationActivity>> {
    return this.http.get<GetManyResponseInterface<IChangeStationActivity>>(this.CHANGE_STATION_ACTIVITY_URL, {
      params,
    });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IChangeStationActivity>> {
    return this.http.get<BaseOneResponseInterface<IChangeStationActivity>>(
      `${this.CHANGE_STATION_ACTIVITY_URL}/${recordId}`,
      { params },
    );
  }

  public addOne(record: IChangeStationActivityRow): Observable<BaseOneResponseInterface<IChangeStationActivity>> {
    return this.http.post<BaseOneResponseInterface<IChangeStationActivity>>(this.CHANGE_STATION_ACTIVITY_URL, record);
  }

  public editOne(
    recordId: number,
    record: IChangeStationActivityRow,
  ): Observable<BaseOneResponseInterface<IChangeStationActivity>> {
    return this.http.patch<BaseOneResponseInterface<IChangeStationActivity>>(
      `${this.CHANGE_STATION_ACTIVITY_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          changeStationActivities: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(
        `${this.CHANGE_STATION_ACTIVITY_URL}/bulk/delete`,
        httpOptions,
      );
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.CHANGE_STATION_ACTIVITY_URL}/${recordIds[0]}`);
  }
}
